import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import InputLabel from '@components/InputLabel';

import { HorizontalRule } from '@layouts/AuthLayout';

import { StyledCheckoutForm, Error } from './CheckoutForm.style';

const messages = defineMessages({
  cardNumber: {
    id: 'checkoutForm.cardNumber',
    defaultMessage: 'Credit Card #',
  },
  expiry: {
    id: 'checkoutForm.expiry',
    defaultMessage: 'Expiry Date',
  },
  cvc: {
    id: 'checkoutForm.cvc',
    defaultMessage: 'Security Code',
  },
});

export default function CheckoutForm({ error = '' }: { error?: string }) {
  const { formatMessage } = useIntl();

  return (
    <StyledCheckoutForm>
      <HorizontalRule />
      <InputLabel label={formatMessage(messages.cardNumber)} />
      <CardNumberElement />
      <InputLabel label={formatMessage(messages.expiry)} />
      <CardExpiryElement />
      <InputLabel label={formatMessage(messages.cvc)} />
      <CardCvcElement />
      {Boolean(error) && <Error>{error}</Error>}
      <HorizontalRule />
    </StyledCheckoutForm>
  );
}
